import { render, staticRenderFns } from "./LoginTypeTabs.vue?vue&type=template&id=28cc7f04&scoped=true&"
import script from "./LoginTypeTabs.vue?vue&type=script&lang=js&"
export * from "./LoginTypeTabs.vue?vue&type=script&lang=js&"
import style0 from "./LoginTypeTabs.vue?vue&type=style&index=0&id=28cc7f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cc7f04",
  null
  
)

export default component.exports